import { IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRequest } from "../../../api/utils/useRequest";
import { BalootUserAPIs } from "../../../api/APIs";
import ContractCard from "../../../components/profile/ContractCard";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";
import StartDirectDebitBanner from "../../../components/home/StartDirectDebitBanner";
import InfoBox from "../../../components/shared/InfoBox";

function ProfileSettingContractPage() {
  const navigate = useNavigate();

  const {
    loading,
    result,
    apiCall: getUserContract,
  } = useRequest(BalootUserAPIs.getUserContract);

  useEffect(() => {
    getUserContract();
  }, []);

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            حساب بانکی متصل
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto", display: "block" }}>
        {loading ? (
          <>
            <CustomRectangularSkeleton height={150} />
          </>
        ) : result?.length === 0 ? (
          <>
            <StartDirectDebitBanner />
            <InfoBox
              sx={{ mt: 2 }}
              title="اتصال به حساب بانکی چه مزایایی دارد؟"
              description={
                <>
                  با اتصال قلک بلوط به حساب بانکی خود از مزایای زیر برخوردار
                  می‌شوید:
                  <br /> فعال‌سازی پس‌انداز خودکار برای داشتن پس‌انداز دوره‌ای و
                  بدون دغدغه <br /> واریز سود دوره‌ای صندوق های درآمد ثابت قلک
                  بلوط برای سرمایه‌گذاری مجدد <br /> خرید مستقیم و سریع صندوق
                  های سرمایه‌گذاری بدون اتصال به درگاه‌ پرداخت
                </>
              }
            />
          </>
        ) : (
          result && (
            <>
              {result.map((contract) => {
                return (
                  <ContractCard
                    key={contract.id}
                    contract={contract}
                    getUserContract={getUserContract}
                  />
                );
              })}
            </>
          )
        )}
      </PageContentContainer>
    </>
  );
}

export default ProfileSettingContractPage;
